import React, { Dispatch, useContext } from "react";
import queryString from "query-string";
import { SetStateAction } from "react";
import { Role } from "./model/ContractViewModel";

export function extractContractParams(search: string): IContractParams {
  const { buyerToken, sellerToken, token } = queryString.parse(search);

  const parsedToken = (token || buyerToken || sellerToken) as
    | string
    | null
    | undefined;

  const contractParams = {
    token: parsedToken || null,
  };

  return contractParams;
}

export interface IContractParams {
  token: string | null;
}

export interface IContractParamsContext extends IContractParams {
  setParams: Dispatch<SetStateAction<IContractParams>>;
}

export const ContractParamsContext =
  React.createContext<IContractParamsContext | null>(null);

export interface ContractToken {
  value: string;
  role: Role;
}

export function useContractParamsContext() {
  const context = useContext(ContractParamsContext);

  if (!context) throw new Error("No ContractParamsContext found!");

  return context;
}
